import script from "./Activity.vue?vue&type=script&setup=true&lang=js"
export * from "./Activity.vue?vue&type=script&setup=true&lang=js"

import "./Activity.vue?vue&type=style&index=0&id=1cdc0066&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cdc0066"]])

export default __exports__